import React from "react";
import {
    Slide,
    Grid,
    FormControl,
    InputLabel,
    Input,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Button,
    Paper
} from "@material-ui/core";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import { useState, useEffect } from "react";
import RequestAccessToken from '../util/authService';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const CareCoordinatorAccount = (props: any) => {
    let {
        userPracticeCoordinatorProfile,
        requestCurrentUserCareCoordinatorProfile,
        submitCareCoordinator
    } = props;

    let [tokenState, setTokenState] = useState<APIStore.TokenType>();
    let [profileState, setProfileState] = useState<APIStore.CareCoordinatorModel>(
        {} as APIStore.CareCoordinatorModel
    );

    RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    useEffect(() => {
        if (userPracticeCoordinatorProfile) {
            let { isErrored, notFound, isLoaded, coordinatorProfile }: APIStore.PracticeCoordinatorState = userPracticeCoordinatorProfile;
            if ((!isErrored && !notFound && !isLoaded) && tokenState?.accessToken) {
                requestCurrentUserCareCoordinatorProfile(tokenState.accessToken);
            } else {
                if (coordinatorProfile?.azureAdAccount) {
                    setProfileState(coordinatorProfile);
                }
            }
        }
    }, [tokenState, userPracticeCoordinatorProfile]);

    if (!userPracticeCoordinatorProfile || !userPracticeCoordinatorProfile.isLoaded) {
        return (<React.Fragment></React.Fragment>);
    }

    const submitUpdate = () => {
        submitCareCoordinator(profileState, tokenState?.accessToken);
    };

    const updateFirstName = (e: any) => {
        let newProfile = {
            ...profileState,
            firstName: e.target.value,
        };
        setProfileState(newProfile);
    };

    const updateLastName = (e: any) => {
        let newProfile = {
            ...profileState,
            lastName: e.target.value,
        };
        setProfileState(newProfile);
    };

    const updatePhone = (e: any) => {
        let newProfile = {
            ...profileState,
            phone: e.target.value,
        };
        setProfileState(newProfile);
    };

    const updateCell = (e: any) => {
        let newProfile = {
            ...profileState,
            cell: e.target.value,
        };
        setProfileState(newProfile);
    };

    const updatePractice = (_e: any) => {
    };

    const handleAlertPref = (event: any) => {
        if (event.target.name === "emailpreferred") {
            setProfileState({
                ...profileState,
                emailPreferred: !profileState.emailPreferred,
            });
        }

        if (event.target.name === "textpreferred") {
            setProfileState({
                ...profileState,
                textPreferred: !profileState.textPreferred,
            });
        }
    };

    if (!profileState?.azureAdAccount) {
        return (
            <React.Fragment>
                <p>Loading</p>
            </React.Fragment>
        );
    }

    let { firstName, lastName, phone, cell, azureAdAccount, practices, defaultPractice } = profileState;

    return (
        <Slide in timeout={1000} direction="left">
            <div className="maincontent">
                <Paper elevation={1} style={{ padding: 50 }}>
                    <Grid container spacing={5}>
                        <Grid item xs={6}>
                            <FormControl>
                                <InputLabel htmlFor="name-input">First Name</InputLabel>
                                <Input
                                    id="name-input"
                                    value={firstName}
                                    aria-describedby="First Name"
                                    onChange={updateFirstName}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <InputLabel htmlFor="my-input">Last Name</InputLabel>
                                <Input
                                    id="my-input"
                                    value={lastName}
                                    aria-describedby="Last Name"
                                    onChange={updateLastName}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <InputLabel htmlFor="phone-number">Phone Number</InputLabel>
                                <Input
                                    id="phone-number"
                                    value={phone}
                                    aria-describedby="Phone number"
                                    onChange={updatePhone}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <InputLabel htmlFor="phone-number">Cell</InputLabel>
                                <Input
                                    id="cell-number"
                                    value={cell}
                                    aria-describedby="Cell number"
                                    onChange={updateCell}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <InputLabel htmlFor="hni-email">HNI Email</InputLabel>
                                <Input
                                    disabled={true}
                                    id="hni-email"
                                    value={azureAdAccount}
                                    aria-describedby="HNI Email"
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <InputLabel id="practice-list-label">Practices</InputLabel>
                                <Select
                                    labelId="practice-list-label"
                                    id="practice-list"
                                    multiple
                                    value={practices}
                                    input={<Input id="select-multiple-chip" />}
                                    onChange={updatePractice}
                                >
                                    {practices.map((practice) => (
                                        <MenuItem
                                            selected={practice.practiceId == defaultPractice.practiceId}
                                            key={practice.practiceId}
                                            value={practice.practiceId}
                                        >
                                            {practice.practiceName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <hr />

                    <Grid item xs={12}>
                        <FormControl required component="fieldset">
                            <FormLabel component="legend">Send me alerts on:</FormLabel>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            key={"emailPref"}
                                            checked={profileState.emailPreferred}
                                            onChange={handleAlertPref}
                                            name="emailpreferred"
                                        />
                                    }
                                    label="Email Preferred"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            key={"textPref"}
                                            checked={profileState.textPreferred}
                                            onChange={handleAlertPref}
                                            name="textpreferred"
                                        />
                                    }
                                    label="Text Preferred"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>

                    <hr />

                    <Grid item xs={12}>
                        <Grid container alignContent='flex-start' alignItems='flex-start' justifyContent='flex-start'>
                            <Button variant="contained" className="btn-primary" size="large" color="primary" disableElevation title="Save" onClick={submitUpdate}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        </Slide>
    );
}

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(CareCoordinatorAccount as any);
